import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {ICopierRow} from './copiers'

export type ICopier = ICopierRow

// 유저별 카피봇 목록. 목록 응답이라 bot/bot_score가 채워져 오므로,
// 카피어 디테일에서 빠져 있는 수치(초기 잔고/입출금/수익률)를 여기서 얻는다.
// 기본 필터는 삭제된 봇을 제외하므로, 삭제된 봇을 찾으려면 filter_status='deleted'가 필요하다.
export const getCopierList = async (
    size?: number,
    current_page: number = 1,
    id?: string,
    filter_status: string = '',
): Promise<ApiRes<ICopier[]>> => {
    return await apiGet(
        API_URL,
        `admin/copy/copiers?page_size=${size}&current_page=${current_page}&user_id=${id}&filter_status=${filter_status}`,
    )
}
